
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useGranjasQuery } from "../../../../hooks";
import { startSavingBodega } from "../../../../services";

import Swal from "sweetalert2";





export const FormCreateUpdateBodega = ({ initialState }) => {


    const { id } = useParams();
    const { granjasListQuery } = useGranjasQuery()
    const queryClient = useQueryClient();



    const [formBodega, setFormBodega] = useState( initialState );
    const { nombre, granja, alto, ancho, largo } = formBodega;
    const  handleChangeInput = ({ target }) => {
        setFormBodega({ ...formBodega, [target.name]: target.value});
    }


    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([nombre, granja, alto, ancho, largo].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Bodega`,
            text: `¿Esta seguro de ${(id) ? 'Actualizar' : 'Crear'} Bodega?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingBodega({...formBodega, id});
        if(resp){
            if(!id) { 
                setFormBodega(initialState); 
            }
            queryClient.invalidateQueries({queryKey: ['bodega-list']});
        }
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                {(granjasListQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        select
                        label="Seleccione Granja"
                        fullWidth
                        name="granja"
                        value={granja || ''}
                        onChange={handleChangeInput}
                    >
                        <MenuItem value="">Seleccione Granja</MenuItem>
                        {Array.isArray(granjasListQuery?.data) && granjasListQuery.data.length > 0 ? (
                            granjasListQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}>
                                    {g.nombre}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay granjas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Alto'
                        type='text'
                        placeholder='Alto'
                        fullWidth
                        name='alto'
                        value={ alto }
                        onChange={ handleChangeInput }
                    />
                </Grid>


                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Ancho'
                        type='text'
                        placeholder='Ancho'
                        fullWidth
                        name='ancho'
                        value={ ancho }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Largo'
                        type='text'
                        placeholder='Largo'
                        fullWidth
                        name='largo'
                        value={ largo }
                        onChange={ handleChangeInput }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Bodega`}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
